module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/409.686858c6.png";